module.exports = __webpack_public_path__ + "img/routing-2.a1778ff5.svg";